import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Grid } from '@mui/material';

import { useLazyQuery } from '@apollo/client';
import i18next from 'i18next';

import PagedTable from 'components/table/PagedTable';
import { filterSelector } from 'helper/filter';
import { userSelector } from 'helper/security';

import { HOTEL_LIST_QUERY } from '../settings/gql';
import { CountryName } from 'components/Language';

export default function AvailabilityHotelSelection() {
  const filter = filterSelector();
  const user = userSelector()!;

  const [query, { loading, error, data }] = useLazyQuery(HOTEL_LIST_QUERY);

  return (
    <>
      <Helmet>
        <title>{i18next.t('availability-hotels-list-page-title')}</title>
      </Helmet>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <PagedTable
            filterKey={`${filter?.spaceId}-${filter?.hotelId}`}
            headers={[
              i18next.t('hotels-list-header-name'),
              i18next.t('hotels-list-header-businesscountry'),
              i18next.t('hotels-list-header-refcode'),
              i18next.t('hotels-list-header-integration'),
              ...(user.isSingleSpace ? [] : [i18next.t('list-header-space')]),
            ]}
            rows={(data?.listHotels?.hotels || []).map(row => [
              <Link to={`hotel/${row.id}`}>{row.name}</Link>,
              <CountryName country={row.businessCountry} />,
              row.refCode,
              row.integrations && row.integrations.length > 0 ? (
                <Link to={`/settings/integration/hotels/${row.integrations[0].id}`}>{row.extRefCode}</Link>
              ) : null,
              ...(user.isSingleSpace ? [] : [row.space.name]),
            ])}
            rowsLoading={loading}
            rowsErr={error}
            totalCount={data?.listHotels?.totalCount}
            refetchPage={(skip, take) =>
              query({
                variables: {
                  spaceId: (filter && filter.spaceId) || null,
                  hotelId: (filter && filter.hotelId) || null,
                  skip,
                  take,
                },
              })
            }
            defaultPageSize={10}
          />
        </Grid>
      </Grid>
    </>
  );
}
